import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "product-detail__buy mbuy",
  "aria-label": "구매 정보"
}
const _hoisted_2 = { class: "product-detail__buy-card" }
const _hoisted_3 = { class: "product-detail__buy-scroll" }
const _hoisted_4 = { class: "product-detail__buy-block" }
const _hoisted_5 = { class: "product-detail__store-row" }
const _hoisted_6 = {
  key: 0,
  class: "product-detail__store"
}
const _hoisted_7 = { class: "product-detail__title" }
const _hoisted_8 = {
  type: "button",
  class: "product-detail__rating"
}
const _hoisted_9 = {
  class: "product-detail__stars",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "product-detail__buy-block" }
const _hoisted_11 = { class: "product-detail__price-row" }
const _hoisted_12 = {
  key: 0,
  class: "product-detail__amount"
}
const _hoisted_13 = {
  key: 1,
  class: "product-detail__amount"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "product-detail__unit"
}
const _hoisted_17 = {
  key: 1,
  class: "product-detail__unit"
}
const _hoisted_18 = {
  key: 2,
  class: "product-detail__unit"
}
const _hoisted_19 = { class: "product-detail__buy-block" }
const _hoisted_20 = { class: "product-detail__buy-facts" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "product-detail__buy-block" }
const _hoisted_25 = { class: "product-detail__options" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  value: ""
}
const _hoisted_28 = ["value", "disabled"]
const _hoisted_29 = {
  key: 3,
  class: "product-detail__picks"
}
const _hoisted_30 = { class: "product-detail__pick-meta" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "product-detail__pick-ops" }
const _hoisted_34 = {
  key: 4,
  class: "product-detail__qty-hint"
}
const _hoisted_35 = { class: "product-detail__buy-block product-detail__buy-block--foot" }
const _hoisted_36 = { class: "product-detail__total" }
const _hoisted_37 = { class: "product-detail__total-copy" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "product-detail__actions" }
const _hoisted_41 = {
  key: 0,
  type: "button",
  class: "product-detail__cta product-detail__cta--restock"
}
const _hoisted_42 = {
  key: 1,
  type: "button",
  class: "product-detail__cta product-detail__cta--buy"
}
const _hoisted_43 = { class: "product-detail__action-row" }
const _hoisted_44 = {
  type: "button",
  class: "product-detail__tool"
}
const _hoisted_45 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import MallOrderPackMark from '@/components/mall/MallOrderPackMark.vue'
import QtyStepper from '@/components/mall/QtyStepper.vue'
import { MALL_FULFILLMENT_LIMIT } from '@/constants/mall'
import { formatPrice, type MallProduct, type MallProductOption } from '@/constants/mallProducts'
import { useSameDayCutoffText } from '@/composables/useContentSnippets'
import { calcMallUnitPrice } from '@/utils/mallPricing'
import { toShippingLine } from '@/utils/mallShipping'
import {
  calcOrderShippingFromLines,
  formatMinOrderLabel,
  formatShippingChargeLabel,
  formatStockCount,
  isOrderPack,
  optionPieceCount,
  sellUnitNoun,
  sellUnitSummary,
  snapOrderQty,
  storefrontOffer,
} from '@/utils/mallSell'

type SelectedLine = {
  key: string
  optionName: string
  optionExtra: number
  qty: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MallProductBuyPanel',
  props: {
    product: {}
  },
  setup(__props: any) {

let selectSeq = 0

const props = __props

const selectId = `mbuy-option-${++selectSeq}`
const optionPick = ref('')

const selectedLines = ref<SelectedLine[]>([])

const { sameDayCutoffText, loadSameDayCutoffSnippet } = useSameDayCutoffText(
  () => props.product.storeCutoff,
)

onMounted(() => {
  void loadSameDayCutoffSnippet()
})

const productOptions = computed(() =>
  (props.product.options ?? []).filter((option) => option.use !== false && option.name.trim()),
)

const optionGroups = computed(() => {
  const groups = new Map<string, MallProductOption[]>()
  productOptions.value.forEach((option) => {
    const groupName = option.group?.trim() || '구성'
    const list = groups.get(groupName) ?? []
    list.push(option)
    groups.set(groupName, list)
  })
  return [...groups.entries()].map(([name, items]) => ({ name, items }))
})

function choiceMoneyLabel(name: string, extra: number) {
  const total = Math.max(0, (Number(props.product.price) || 0) + (Number(extra) || 0))
  const qty = optionPieceCount(name)
  const totalText = `${formatPrice(total)}원`
  if (qty === 1) return `${name} ${totalText}`
  if (qty && qty > 1) return `${name} ${totalText} · 개당 ${formatPrice(Math.round(total / qty))}원`
  if (extra) return `${name} (${extra > 0 ? '+' : ''}${formatPrice(extra)}원)`
  return name
}

const flatOptionChoices = computed(() => {
  const groups = optionGroups.value
  if (!groups.length) return [] as Array<{ name: string; label: string; extra: number; stock: number; front: boolean }>

  const flatItems = groups.flatMap((group) => group.items)
  const quantityList =
    flatItems.length > 0 && flatItems.every((option) => optionPieceCount(option.name) != null)
  if (groups.length === 1 || quantityList) {
    return (quantityList ? flatItems : groups[0].items)
      .map((option) => ({
        name: option.name,
        label: choiceMoneyLabel(option.name, option.extra),
        extra: option.extra,
        stock: option.stock,
        front: option.front === true,
      }))
      .sort((a, b) => (optionPieceCount(a.name) ?? 9999) - (optionPieceCount(b.name) ?? 9999))
  }

  const [first, ...rest] = groups
  let combos = first.items.map((option) => ({
    parts: [option.name],
    extra: option.extra,
    stock: option.stock,
  }))
  rest.forEach((group) => {
    const next: typeof combos = []
    combos.forEach((combo) => {
      group.items.forEach((option) => {
        next.push({
          parts: [...combo.parts, option.name],
          extra: combo.extra + option.extra,
          stock: Math.min(combo.stock, option.stock),
        })
      })
    })
    combos = next
  })

  return combos.map((combo) => {
    const name = combo.parts.join(' / ')
    return {
      name,
      label: choiceMoneyLabel(name, combo.extra),
      extra: combo.extra,
      stock: combo.stock,
      front: false,
    }
  })
})

const hasDefaultChoice = computed(() =>
  flatOptionChoices.value.some(
    (item) => item.front || optionPieceCount(item.name) === 1 || item.extra === 0,
  ),
)

const tracksOptionStock = computed(() => {
  const choices = flatOptionChoices.value
  if (choices.length && choices.every((item) => optionPieceCount(item.name) != null)) return false
  return choices.some((item) => item.stock > 0)
})

function isChoiceAvailable(choice: { stock: number }) {
  if (props.product.soldOut) return false
  if (!tracksOptionStock.value) return true
  return choice.stock > 0
}

function choiceLabel(choice: { name: string; label: string; stock: number }) {
  return isChoiceAvailable(choice) ? choice.label : `${choice.label} · 품절`
}

const sellNoun = computed(() => sellUnitNoun(props.product.sellUnit))
const sellSummary = computed(() => sellUnitSummary(props.product))
const productShippingLabel = computed(() => {
  const label = formatShippingChargeLabel(props.product)
  return label === '무료' ? '무료배송' : label
})
const minQty = computed(() => Math.max(1, props.product.minOrder || 1))
const orderStep = computed(() => Math.max(1, props.product.orderStep || 1))
const isPack = computed(() => isOrderPack(orderStep.value))
const isGroupBuy = computed(() => props.product.mallKind === 'SALE')
const cartonPieces = computed(() => Math.max(1, props.product.packQty || orderStep.value || 1))
const stockQty = computed(() => Math.max(0, Number(props.product.stock) || 0))
const maxQty = computed(() => {
  const stock = stockQty.value
  return Math.max(minQty.value, stock > 0 ? stock : minQty.value)
})
const qtyHint = computed(() => {
  if (props.product.soldOut || stockQty.value <= 0) return '품절'
  if (isPack.value) return ''
  if (minQty.value > 1) return formatMinOrderLabel(minQty.value, props.product.sellUnit)
  return ''
})

function clampQty(value: number) {
  return snapOrderQty(value, minQty.value, orderStep.value, maxQty.value)
}

function cartonCount(qty: number) {
  return Math.max(1, Math.round((Number(qty) || cartonPieces.value) / cartonPieces.value))
}

const priced = computed(() =>
  calcMallUnitPrice({
    listPrice: props.product.listPrice,
    salePrice: props.product.price,
  }),
)

const cartonPrice = computed(() => priced.value.unitPrice * cartonPieces.value)

function lineUnitPrice(optionExtra = 0): number {
  return calcMallUnitPrice({
    listPrice: props.product.listPrice,
    salePrice: props.product.price,
    optionExtra,
  }).unitPrice
}

function seedDefaultLine() {
  selectedLines.value = []
  optionPick.value = ''
  const choices = flatOptionChoices.value
  const choice =
    choices.find((item) => item.front && isChoiceAvailable(item)) ??
    choices.find((item) => item.front) ??
    choices.find((item) => optionPieceCount(item.name) === 1 && isChoiceAvailable(item)) ??
    choices.find((item) => optionPieceCount(item.name) === 1) ??
    choices.find((item) => item.extra === 0 && isChoiceAvailable(item)) ??
    choices.find((item) => item.extra === 0)
  if (!choice) return
  optionPick.value = choice.name
  if (!isChoiceAvailable(choice)) return
  selectedLines.value = [
    {
      key: `${props.product.id}::${choice.name}`,
      optionName: choice.name,
      optionExtra: choice.extra,
      qty: clampQty(minQty.value),
    },
  ]
}

watch(
  () => {
    const options = productOptions.value
      .map((option) => `${option.group}:${option.name}:${option.extra}:${option.stock}:${option.front}`)
      .join('|')
    return `${props.product.soldOut ? 1 : 0}|${options}`
  },
  () => {
    seedDefaultLine()
  },
  { immediate: true },
)

watch(maxQty, () => {
  selectedLines.value.forEach((line) => {
    line.qty = clampQty(line.qty)
  })
})

function onOptionPick() {
  const name = optionPick.value
  if (!name) return
  const choice = flatOptionChoices.value.find((item) => item.name === name)
  if (!choice || !isChoiceAvailable(choice)) {
    optionPick.value =
      selectedLines.value[0]?.optionName ||
      flatOptionChoices.value.find((item) => isChoiceAvailable(item))?.name ||
      ''
    return
  }
  if (selectedLines.value[0]?.optionName === name) return
  selectedLines.value = [
    {
      key: `${props.product.id}::${name}`,
      optionName: name,
      optionExtra: choice.extra,
      qty: clampQty(1),
    },
  ]
}

function setLineQty(key: string, raw: string | number) {
  const line = selectedLines.value.find((item) => item.key === key)
  if (!line) return
  const parsed = typeof raw === 'number' ? raw : Number(String(raw).trim())
  line.qty = clampQty(Number.isFinite(parsed) ? Math.trunc(parsed) : minQty.value)
}

const goodsAmount = computed(() => {
  if (selectedLines.value.length) {
    return selectedLines.value.reduce((sum, line) => sum + lineUnitPrice(line.optionExtra) * line.qty, 0)
  }
  return priced.value.unitPrice * minQty.value
})

const pickQty = computed(() => {
  if (selectedLines.value.length) {
    return selectedLines.value.reduce((sum, line) => sum + line.qty, 0)
  }
  return minQty.value
})

const orderShippingFee = computed(() =>
  calcOrderShippingFromLines([toShippingLine(props.product, pickQty.value)]),
)

const totalAmount = computed(() => goodsAmount.value + orderShippingFee.value)

const headlineOffer = computed(() => storefrontOffer(props.product))
const headlinePrice = computed(() => {
  const line = selectedLines.value[0]
  if (line && props.product.mallKind !== 'SALE') return lineUnitPrice(line.optionExtra)
  return headlineOffer.value.price || priced.value.unitPrice
})
const headlineName = computed(() => {
  if (props.product.mallKind === 'SALE') return ''
  return selectedLines.value[0]?.optionName || headlineOffer.value.name
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.product.storeName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.product.storeName), 1))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "product-detail__tools" }, [
              _createElementVNode("button", {
                type: "button",
                class: "product-detail__compare"
              }, "공유하기"),
              _createElementVNode("button", {
                type: "button",
                class: "product-detail__compare"
              }, "찜하기")
            ], -1))
          ]),
          _createElementVNode("h1", _hoisted_7, _toDisplayString(__props.product.name), 1),
          _createElementVNode("button", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                return _createVNode(AppIcon, {
                  key: star,
                  icon: star <= Math.round(__props.product.rating) ? 'mdi-star' : 'mdi-star-outline',
                  size: 15
                }, null, 8, ["icon"])
              }), 64))
            ]),
            _createElementVNode("strong", null, _toDisplayString(__props.product.rating.toFixed(1)), 1),
            _createElementVNode("em", null, "구매후기 " + _toDisplayString(_unref(formatPrice)(__props.product.reviewCount)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (isGroupBuy.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(formatPrice)(cartonPrice.value)), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("em", null, "원", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("small", null, "/카톤", -1))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_unref(formatPrice)(headlinePrice.value)), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("em", null, "원", -1)),
                  (headlineName.value)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(headlineName.value), 1))
                    : (sellNoun.value === '박스')
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, "/박스"))
                      : _createCommentVNode("", true)
                ]))
          ]),
          (isGroupBuy.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(cartonPieces.value) + "개 묶음 · 1개당 " + _toDisplayString(_unref(formatPrice)(priced.value.unitPrice)) + "원", 1))
            : (!headlineName.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                  _createTextVNode(_toDisplayString(sellSummary.value), 1),
                  (__props.product.unit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(__props.product.unit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : (__props.product.unit)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(__props.product.unit), 1))
                : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: _normalizeClass(["product-detail__stock", { 'is-out': __props.product.soldOut || stockQty.value <= 0 }])
          }, [
            (__props.product.soldOut || stockQty.value <= 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("품절")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("재고 " + _toDisplayString(_unref(formatStockCount)(stockQty.value, __props.product.sellUnit)), 1)
                ], 64))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("dl", _hoisted_20, [
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("dt", null, "배송비", -1)),
              _createElementVNode("dd", null, _toDisplayString(productShippingLabel.value), 1)
            ]),
            (__props.product.leadTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[6] || (_cache[6] = _createElementVNode("dt", null, "출고", -1)),
                  _createElementVNode("dd", null, _toDisplayString(__props.product.leadTime), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "수령", -1)),
              _createElementVNode("dd", null, _toDisplayString(_unref(MALL_FULFILLMENT_LIMIT)), 1)
            ]),
            (__props.product.origin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[8] || (_cache[8] = _createElementVNode("dt", null, "원산지", -1)),
                  _createElementVNode("dd", null, _toDisplayString(__props.product.origin), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(sameDayCutoffText))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[9] || (_cache[9] = _createElementVNode("dt", null, "당일 출고", -1)),
                  _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (!isGroupBuy.value)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "product-detail__option-label",
                  for: selectId
                }, [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" 옵션 선택 ", -1),
                  _createElementVNode("em", null, "(필수)", -1)
                ]))]))
              : _createCommentVNode("", true),
            (!isGroupBuy.value)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  id: selectId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((optionPick).value = $event)),
                  class: "product-detail__option-select",
                  disabled: __props.product.soldOut || !flatOptionChoices.value.length,
                  onChange: onOptionPick
                }, [
                  (!hasDefaultChoice.value)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_27, "옵션을 선택하세요"))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatOptionChoices.value, (choice) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: choice.name,
                      value: choice.name,
                      disabled: !isChoiceAvailable(choice)
                    }, _toDisplayString(choiceLabel(choice)), 9, _hoisted_28))
                  }), 128))
                ], 40, _hoisted_26)), [
                  [_vModelSelect, optionPick.value]
                ])
              : _createCommentVNode("", true),
            (isPack.value && !isGroupBuy.value)
              ? (_openBlock(), _createBlock(MallOrderPackMark, {
                  key: 2,
                  size: "detail",
                  "order-step": orderStep.value,
                  "sell-unit": __props.product.sellUnit
                }, null, 8, ["order-step", "sell-unit"]))
              : _createCommentVNode("", true),
            (selectedLines.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLines.value, (line) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: line.key
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("strong", null, _toDisplayString(isGroupBuy.value ? '1카톤' : line.optionName), 1),
                        (isGroupBuy.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(formatPrice)(lineUnitPrice(line.optionExtra) * cartonPieces.value)) + "원 × " + _toDisplayString(cartonCount(line.qty)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(formatPrice)(lineUnitPrice(line.optionExtra))) + "원 × " + _toDisplayString(line.qty), 1))
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(QtyStepper, {
                          "model-value": line.qty,
                          min: minQty.value,
                          max: maxQty.value,
                          step: orderStep.value,
                          unit: sellNoun.value,
                          carton: isGroupBuy.value,
                          "onUpdate:modelValue": ($event: any) => (setLineQty(line.key, $event))
                        }, null, 8, ["model-value", "min", "max", "step", "unit", "carton", "onUpdate:modelValue"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (qtyHint.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(qtyHint.value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "주문금액", -1)),
            (orderShippingFee.value > 0)
              ? (_openBlock(), _createElementBlock("em", _hoisted_38, "주문 배송비 " + _toDisplayString(_unref(formatPrice)(orderShippingFee.value)) + "원 포함", 1))
              : (_openBlock(), _createElementBlock("em", _hoisted_39, "주문 배송비 무료"))
          ]),
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(totalAmount.value)), 1),
            _cache[12] || (_cache[12] = _createElementVNode("em", null, "원", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          (__props.product.soldOut)
            ? (_openBlock(), _createElementBlock("button", _hoisted_41, " 재입고 알림 신청 "))
            : (_openBlock(), _createElementBlock("button", _hoisted_42, " 바로구매 ")),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", _hoisted_44, [
              _createVNode(AppIcon, {
                icon: "mdi-heart-outline",
                size: 20
              }),
              _cache[13] || (_cache[13] = _createTextVNode(" 찜하기 ", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "product-detail__tool",
              disabled: __props.product.soldOut
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-cart-outline",
                size: 20
              }),
              _cache[14] || (_cache[14] = _createTextVNode(" 장바구니 ", -1))
            ], 8, _hoisted_45)
          ])
        ])
      ])
    ])
  ]))
}
}

})